export default __webpack_public_path__ + "static/media/background1.355a0931.jpg";